module.exports = __webpack_public_path__ + "img/Unidad20-5.801d60e7.png";